<template>
    <div>
        <v-text-field
            v-model="color"
            outlined
            dense
            :readonly="readonly"
            :color="inputColor"
            :background-color="backgroundColor"
            @click="menu = true"
            :clearable="!readonly"
            hide-details="auto"
        >
            <template v-slot:append>
                <v-menu
                    v-model="menu"
                    :disabled="readonly"
                    top
                    nudge-bottom="105"
                    nudge-left="16"
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ on }">
                        <div :style="swatchStyle" v-on="on"/>
                    </template>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-color-picker v-model="color" show-swatches flat/>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </template>
        </v-text-field>

        <input type="hidden"/>
    </div>
</template>

<script>
import {computed, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    props: {
        value: String,
        readonly: Boolean,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor} = useSharedData();

        const color = ref("#FFFFFF");
        const menu = ref(false);

        const swatchStyle = computed(() => {

            return {
                backgroundColor: color.value,
                cursor: "pointer",
                height: "25px",
                width: "60px",
                borderRadius: menu.value ? "50%" : "4px",
                transition: "border-radius 200ms ease-in-out",
            }
        });

        watch(() => props.value, () => {
            color.value = props.value;
        }, {immediate: true});

        watch(() => color.value, () => {
            if ((typeof color.value == "string")) {
                emit("input", color.value);
            } else {
                emit("input", '#FFFFFF');
            }
        });

        return {
            inputColor,
            backgroundColor,
            color,
            menu,
            swatchStyle,
        }
    }
};
</script>